<template>
  <div>
    <Banner class="z-banner"
            :name="blockData.id"
            v-if="((blockData.floorStyle ? blockData.floorStyle : blockData.floorType) == 'banner')&&(blockData.floorType=='banner'||blockData.floorType=='busbanner')"
            :pictures="blockData.dataArr"
            :nodeId="blockData.nodeId"
            :blockData="blockData" />
    <div @contextmenu.prevent="$emit('windowRightMenu',$event,'floor')"
         :style="{'width':isPC?'1200px':'','margin':'0 auto'}">
      <!-- 移动端显示客户端时需要'height':(!isPC&&blockData.floorType=='sceneArchThirdShow'&&$store.state.userInfo.userId)?680*scale+'px':'' -->
      <!-- 货架层 -->
      <nBanner v-if="((blockData.floorStyle ? blockData.floorStyle : blockData.floorType) == 'busbanner')&&(blockData.floorType=='banner'||blockData.floorType=='busbanner')"
               :name="blockData.id"
               :pictures="blockData.dataArr"
               :blockData="blockData" />
      <!-- 客户端开始 -->
      <div v-else-if="blockData.floorType=='sceneArchThirdShow'&&$store.state.userInfo.userId&&!IsMobile()&&isPC&&isTop"
           :style="{'margin-top':'26px','transform':!isPC?'scale('+scale+')':'','transformOrigin':!isPC?'0 0':''}"
           class="z-container">
        <iframe id="testiframe"
                :src = "(window.location.hostname == '520emv.com') ? '/aassid/?appId=myb&sourceType=wz' : '/aassid/?sourceType=wz'"
                style="border-bottom:1px solid #ddd;"
                frameborder="0"
                width="1200px"
                height="680px"></iframe>
      </div>
      <!-- 客户端结束 -->
      <Search v-else-if="blockData.floorType=='search'" />
      <!-- 专项客户端 -->
      <specialClient v-else-if="blockData.floorType=='swindow'" :blockData="blockData"></specialClient>
      <!-- 直播街区楼层 -->
      <div v-else-if="blockData.floorType=='screenshow'">
        <tit :blockData="blockData"></tit>
        <iframe id="liveiframe"
                src= '/meeting-tool-web/sso/live/index'
                style="border:1px solid #ddd;margin-top:20px;"
                frameborder="0"
                width="1200px"
                height="680px"></iframe>
      </div>
      <div v-else-if="blockData.floorType!='banner'&&blockData.floorType!='busbanner'&&blockData.floorType!='sceneArchThirdShow'"
           class="z-container">
        <smartAppSameScreenShow v-if="blockData.floorType!='companyIntroduce'"
                                :floorIndx="floorIndx"
                                :indexs="indexs"
                                :baseNavHeight="navHeight"
                                :_centerStyle="centerStyle"
                                :blockData="blockData">
        </smartAppSameScreenShow>
        <companyIntroduce v-else
                          :blockData="blockData"></companyIntroduce>
      </div>
    </div>
  </div>
</template>
<script>
import tit from "./floorBlock/control/tit.vue"
import Banner from "../components/Banner.vue";
import nBanner from "../components/newBanner.vue";
import smartChart from "./floorBlock/chart.vue";
import tradeNews from "./floorBlock/hycm.vue";
import companyIntroduce from "./floorBlock/qyjj.vue";
import smartApp from "./floorBlock/zncp.vue";
import smartAppSameScreenShow from "./floorBlock/zncpMain";
import sceneArchMainShow from "./floorBlock/sceneArchMainShow.vue";
import sceneArchSecondShow from "./floorBlock/sceneArchSecondShow.vue";
import sceneLives from "./floorBlock/sceneLives.vue";
import knowledgeCenter from "./floorBlock/zszx.vue";
import flowArchShow from "./floorBlock/flowArchShow.vue";
import Search from "./floorBlock/search.vue";
import haowu from '../components/haowutuijian.vue'
import Seckill from '../components/seckill.vue'
import specialClient from '../components/specialClient.vue'

export default {
  name: "FloorBlock",
  components: {
    tit,
    Banner,
    smartChart,
    tradeNews,
    companyIntroduce,
    smartApp,
    smartAppSameScreenShow,
    sceneArchMainShow,
    sceneArchSecondShow,
    sceneLives,
    flowArchShow,
    knowledgeCenter,
    Search,
    nBanner,
    haowu,
    Seckill,
    specialClient
  },
  props: {
    blockData: {
      type: Object
    },
    floorIndx: {
      type: Number
    },
    rightShow: {
      type: Boolean
    },
    indexs: Number,
    seckill: Object,
    member: Object
  },
  data () {
    return {
      window:window,
      widths: window.innerWidth,
      component: null,
      showType: 'banner',
      iframeShow: true,
      scale: (window.innerWidth - 20) / 1200
    }
  },
  computed: {
    isPC () {
      return this.widths > 768
    },
    isTop(){
      return top == self
    },
    centerStyle () {
      return this.blockData.floorStyle ? this.blockData.floorStyle : this.blockData.floorType
    },
    navHeight () {
      /**
       * 楼层高度 基准值
       * 标准楼层 navHeight 425
       * 知识中心 navHeight 532
       * 行业传媒 navHeight 387
       * 场景架构 navHeight 480
       */

      var baseHei = 425;
      const floorType = this.componentTem;
      switch (floorType) {
        case 'knowledgeCenter':
          baseHei = 425;
          break;
        case 'tradeNews':
          baseHei = 387;
          break;
        case 'sceneArchMainShow':
          baseHei = 902;
          break;
        case 'sceneArchSecondShow':
          baseHei = 500;
          break;
        case 'sceneLives':
          baseHei = 500;
          break;
        case 'flowArchShow':
          baseHei = 326;
          break;
        default:
          baseHei = 425;
      }

      const centerStyle = this.centerStyle;
      switch (centerStyle) {
        case 'enterprisAlliance':
          baseHei = 331;
          break;
        case 'expertsAlliance':
          baseHei = 425;
          break;
        case 'article':
          baseHei = 331;
          break;
      }
      return baseHei;
    },
  },
  created () {
    // if (this.blockData.floorType == 'banner' || this.blockData.floorType == 'busbanner') {
    //   this.getFlowOrBlockByFlowId();
    // }
    if (self != top) {
      this.iframeShow = false;
    }
    window.addEventListener('resize', () => {
      this.widths = window.innerWidth;
      this.scale = (window.innerWidth - 20) / 1200;
    })
  },
  mounted(){
    this.$nextTick(()=>{
      if(topWin){
        topWin = $('#testiframe').length ? $('#testiframe')[0].contentWindow : window;
      }
    })
  },
  methods: {
    getFloorShowStyle (blockData) {
      this.$http
        .get("/zciid-deliverable/showPlatformStyle/flow/api/getShowFlowPosition.json", {
          appId: blockData.appId,
          flowId: blockData.id,
          flowOrDetail: 'floor-style',
          domainNameType: document.location.pathname.split('/')[1]
        }).then(res => {
          this.centerStyle = '';
          if (res.state == 1) {
            // this.centerStyle = (['expertsAlliance','enterprisAlliance'].indexOf(res.data)>-1)?'':res.data;
            this.centerStyle = res.data;
          } else {
            this.centerStyle = this.blockData.floorType;
          }
        })
    },
    //获取banner层中间块展示方式
    getFlowOrBlockByFlowId () {
      var _this = this;
      _this.$http
        .get("/zciid-deliverable/showPlatformStyle/flow/api/get/getFlowFloorDataSpit.json", {
          // appId: _this.blockData.appId,
          appId: _this.getQuery('appId'),
          flowId: _this.blockData.id,
          diyPageFlowId: '',
          domainNameType: document.location.pathname.split('/')[1]
        }).then(res => {
            _this.showType = res.data[0].floorStyle ? res.data[0].floorStyle : _this.blockData.floorType;
        })
    },
  }
};
</script>
<style scoped>
@import url("../assets/css/home.css");
</style>


// WEBPACK FOOTER //
// src/components/floorBlock.vue